import Link from 'next/link';
import Image from 'next/image';
import PropTypes from 'prop-types';
import Styles from './Header.module.scss';
import MyImage from 'components/MyImage';

export default function Header({ section }) {
    if (section === 'home') {
        return (
            <header
                className={`container is-fluid text-center ${Styles.header} ${Styles.home} hero is-primary is-bold`}
            >
                <div className="hero-body">
                    <div className="container has-text-centered">
                        {/* <Image
                            src="/images/badge-min.png"
                            alt="Bruno Domingos"
                            width={80}
                            height={80}
                            layout="fixed"
                            loading="eager"
                        /> */}

                        <MyImage
                            src="/badge-min.png"
                            alt="Bruno Domingos"
                            width={80}
                            height={80}
                            layout="fixed"
                            loading="eager"
                        />

                        <h1 className="title is-uppercase mt-3 is-unselectable">Bruno Domingos</h1>
                        <h2 className="subtitle has-text-info is-unselectable">
                            doing stuff for the web since 2010
                        </h2>
                    </div>
                </div>
            </header>
        );
    }
    return (
        <header className={`container is-fluid text-center ${Styles.header} hero is-primary`}>
            <Link href="/">
                <a>
                    {/* <Image
                        src="/images/badge-min.png"
                        alt="Bruno Domingos"
                        width={50}
                        height={50}
                        layout="fixed"
                        loading="eager"
                    /> */}
                    <MyImage
                        src="/badge-min.png"
                        alt="Bruno Domingos"
                        width={50}
                        height={50}
                        layout="fixed"
                        loading="eager"
                    />
                </a>
            </Link>
        </header>
    );
}

Header.propTypes = {
    section: PropTypes.string,
};
